<template>
  <svg width="28" height="22" viewBox="0 0 28 22" fill="#0086C8" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.6667 0.333008H3.33335C1.86002 0.333008 0.68002 1.52634 0.68002 2.99967L0.666687 18.9997C0.666687 20.473 1.86002 21.6663 3.33335 21.6663H24.6667C26.14 21.6663 27.3334 20.473 27.3334 18.9997V2.99967C27.3334 1.52634 26.14 0.333008 24.6667 0.333008ZM24.6667 5.66634L14 12.333L3.33335 5.66634V2.99967L14 9.66634L24.6667 2.99967V5.66634Z"/>
  </svg>
</template>
<script>
export default {
  name: 'IconEmailUs'
}
</script>